<style lang="scss" scoped>
.item {
    margin: -8px;
    padding: 8px;
    cursor: pointer;
    &:hover {
        background: var(--white-hover);
    }
}
.user-avatar {
    height: 47px;
    width: 47px;
    border-radius: 50%;
}
::v-deep label {
    background: #0000;
}
</style>

<template>
    <div class="mb-8 pl-16 item border-radius-sm" @click="open = !open">

        <div class="d-flex">
            <!-- Select -->

            <div @click.stop class="my-auto">
                <p-check v-model="localValue" @change="handleInput" class="p-round p-smooth p-default mr-16" color="success-o" name="check"></p-check>
            </div>

            <!-- Avatar -->
            <div v-if="data.actionable_type === 'action_type.user' || data.actionable_type === 'action_type.psychologist'" class="mr-16 position-relative">
                <el-avatar :user="data.actionable"></el-avatar>
                <span v-if="data.priority === 2" class="d-inline-block  position-absolute" style="width: 11px; height: 11px; background-color: #ff2d55; border-radius: 50%; right: 5px; top: 5px;"></span>
                <span v-if="data.priority === 1" class="d-inline-block  position-absolute" style="width: 11px; height: 11px; background-color: #ffbd26; border-radius: 50%; right: 5px; top: 5px;"></span>
            </div>

            <!-- content -->
            <div class="d-flex">
                <div class="my-auto" v-if="data.actionable_type === 'action_type.user' || data.actionable_type === 'action_type.psychologist'">
                    <p v-if="data.actionable" class="fw-b small text-primary-dark mb-0"> {{ data.actionable.first_name }} {{ data.actionable.last_name }}</p>
                    <p class="text-dark mb-0">{{ $t(data.message) }}</p>
                </div>
            </div>

            <!-- options -->
            <!-- <i-settings @click.stop class="i-20 ml-auto my-auto"></i-settings> -->
        </div>
        <div v-show="open" @click.stop class="py-16">
            <a v-if="data.actionable_type === 'action_type.user' || data.actionable_type === 'action_type.psychologist' && data.actionable.email" href="mailto:${user.actionable.email}" class="btn btn-gold ml-44 mr-16">{{ $t('pages.dashboard.mail_person', { name: data.actionable.first_name }) }}</a>
            <a v-if="data.actionable_type === 'action_type.user' && data.actionable.phone" href="tel:${user.actionable.phone}" class="btn btn-gold mr-24">{{ $t('pages.dashboard.call_person', { name: data.actionable.first_name }) }}</a>
            <router-link v-if="data.actionable_type === 'action_type.user'" :to="{ name: 'admin-show-patient', params: {id: data.actionable_id } }">{{ $t('pages.dashboard.view_patient') }}</router-link>
            <router-link v-if="data.actionable_type === 'action_type.psychologist'" :to="{ name: 'admin-psychologists-show', params: {id: data.actionable_id } }">{{ $t('pages.dashboard.view_psychologist') }}</router-link>
        </div>
    </div>
</template>

<script>
import { PCheck } from '@/components/forms'
import { ElAvatar } from '@/components/forms'

export default {
    components: { PCheck, ElAvatar },
    props: {
        data: {
            required: true
        },
        value: {
            required: true,
            type: Boolean
        }
    },
    data: () => ({
        open: false,
        localValue: false
    }),
    mounted() {
        this.localValue = this.value
    },
    methods: {
        handleInput() {
            let data = {
                id: this.data.id,
                done: this.localValue
            }
            this.$store.dispatch('admins/updateActions', data).then(() => {
                this.$emit('input', this.localValue)
            })
        }
    },
    watch: {
        value: function () {
            this.localValue = this.value
        }
    }
}
</script>
